import { createFileRoute } from "@tanstack/react-router";

import AddSongkick from "@/features/onboarding/AddSongkick";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-songkick")({
  component: () => (
    <BasicLayout>
      <AddSongkick />
    </BasicLayout>
  ),
});
